import { Component, AfterViewChecked, inject, ChangeDetectorRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DividerComponent } from '@r1-compass-library/components';
import { AdditionalFieldsMapperComponent } from './mappers-ui/additional-fields-mapper.component';
import { DatamartComponent } from './mappers-ui/datamart.component';
import { MultipleRecommendationsComponent } from './mappers-ui/multiple-recommendations.component';
import { LifecycleRulesComponent } from './mappers-ui/lifecycle-rules.component';
import { ExpiryProcessComponent } from './mappers-ui/expiry-process.component';
import { DivisionBasicSettingsFormService } from './division-basic-settings-form.service';
import { MatButtonModule } from '@angular/material/button';
import { SaveDivisionSettingsFooterComponent } from '../save-footer.component';
import { FormUnsavedChangesWarningDivisionSettings } from '@r1-compass-library/guards/hasUnsavedChanges.guard';
import { SaveGuardStore } from '@r1-compass-library/guards/save-guard.store';

@Component({
    selector: 'r1-compass-app-division-basic-settings',
    imports: [
        ReactiveFormsModule,
        DividerComponent,
        AdditionalFieldsMapperComponent,
        DatamartComponent,
        MultipleRecommendationsComponent,
        LifecycleRulesComponent,
        ExpiryProcessComponent,
        MatButtonModule,
        SaveDivisionSettingsFooterComponent,
    ],
    template: `
        <form [formGroup]="formService.divisionBasicSettingsForm" (ngSubmit)="onSave()">
            <section id="sources">
                <r1-compass-app-datamart />

                <r1-compass-lib-divider />

                <r1-compass-app-multiple-recommendations />

                <r1-compass-lib-divider />

                <r1-compass-app-lifecycle-rules />

                <r1-compass-lib-divider />

                <r1-compass-app-expiry-process />
            </section>

            <r1-compass-lib-divider />

            <section id="mapper">
                <r1-compass-app-additional-fields-mapper />
            </section>

            <r1-compass-app-save-division-settings-footer [disabled]="!formService.divisionBasicSettingsForm.valid" />
        </form>
    `,
    providers: [DivisionBasicSettingsFormService],
})
export class DivisionBasicSettingsComponent implements AfterViewChecked, FormUnsavedChangesWarningDivisionSettings {
    readonly #cdr = inject(ChangeDetectorRef);
    protected readonly formService = inject(DivisionBasicSettingsFormService);
    readonly #formSaveWarningStore = inject(SaveGuardStore);

    canDeactivate$ = this.#formSaveWarningStore.deriveCanDeactivate$(this.formService.divisionBasicSettingsForm);
    saveGuardHandlerFn = this.#formSaveWarningStore.formUnsavedChangesWarningDivisionSettings;

    constructor() {
        this.saveGuardHandlerFn({
            form: this.formService.divisionBasicSettingsForm,
            canDeactivate$: this.canDeactivate$,
        });
    }

    ngAfterViewChecked(): void {
        this.#cdr.detectChanges();
    }

    public onSave() {
        // [disabled]="!formService.divisionDataMappingForm.valid"
        return this.formService.submit();
    }
}
